import { useEffect, useState } from 'react'

//Funciones comunes
import { LogErrors } from './../../../../utilities/LogErrors'
import { useLanguage } from './../../../../utilities/LanguageContext'

//Componentes comunes
import { Loading } from './../../../Common/Loading'
import { GoToBack } from './../../../Common/GoToBack'
import { EnableAllRestrictions, DisableAllRestrictions } from './../../../../utilities/BL/Security'
import { Disabled } from './../../Common/Disabled'


const Activity = ({ activityName, instrument, isInstrumentEnabled }) => {
    const { translate } = useLanguage() // Obtén la función de traducción desde el contexto
    
    const [activity, setActivity] = useState({})
    const [isLoading, setIsLoading] = useState(true)


    const LoadPage = async () => {
        try {
            document.body.classList.add('BodyComplete')
            
            setActivity(instrument.activity)
        } catch (error) {
            await LogErrors('LoadPage - Activity', error)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        LoadPage()
    },[]) // El array vacío [] asegura que useEffect se ejecute solo una vez, al montar

    useEffect(() => {
        EnableAllRestrictions()

        return () => {
            DisableAllRestrictions()
        }
    }, [])


    return (
        isLoading ? (
            <Loading />
        ) : (
            isInstrumentEnabled === true ? (
                <>
                    <div className='container'>
                        <GoToBack url={'/course'} extraClassName={'mt-5'} />
                    </div>

                    <main className='container Activity--V2 Container-FullHeight'>
                        <div className='Activity--V2__Instructions Tables--Shadow'>
                            <div className='Activity--V2__Instructions__Header'>
                                <p className='Activity--V2__Text--Title'>{activityName}</p>

                                <a className='Btn__Ztudia--Primary Activity--V2__Instructions__Header__DownloadButton' href={activity.downloadFile} download><i className='bi bi-download'></i> Descargar archivo</a>
                            </div>

                            <p dangerouslySetInnerHTML={{ __html: activity.instructions }} />
                        </div>
                    </main>
                </>
            ) : (
                <main className='Container-FullHeight'>
                    <Disabled />
                </main>
            )
        )
    )
}

export { Activity };